import React, { useState, useEffect } from 'react';
import useAPI from '../../../../api';
import Dialog from '../../../../Components/Dialog';
import NoteAddRoundedIcon from '@mui/icons-material/NoteAddRounded';
import DriveFileRenameOutlineRoundedIcon from '@mui/icons-material/DriveFileRenameOutlineRounded';
import DialogContent from './DialogContent';
import { useAtomValue } from 'jotai';
import { selectedBranchAtom } from '../../../../Atoms';
import keysMapper from '../../../PracticesPage/Utils/keysMapper';

const PracticeDialog = function PracticeDialog({
  open,
  onClose,
  onSubmit,
  edit,
  data,
  entityId = null,
  commercialCampaignId,
  parentId,
}) {
  const API = useAPI();
  const selectedBranch = useAtomValue(selectedBranchAtom);
  const [inEditing, setInEditing] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [customerData, setCustomerData] = useState(null);

  const handleEditPractice = () => {
    setInEditing(true);
    setCurrentPage(0);
  };

  const getCustomer = (entityId) => {
    if (!entityId || !selectedBranch) return;

    API.getCustomer(
      entityId,
      selectedBranch.id,
      (result) => {
        setCustomerData({
          ...keysMapper(result),
          campaignId: commercialCampaignId,
          parentId,
          entityId,
        });
      },
      (err) => {
        console.log(err);
      }
    );
  };
  useEffect(() => {
    if (entityId) {
      getCustomer(entityId);
    }
  }, [entityId]);

  useEffect(() => {
    if (!open) {
      setCustomerData(null);
      setInEditing(false);
      setCurrentPage(0);
    }
  }, [open]);

  return (
    <Dialog
      id="practice-dialog"
      open={open}
      onClose={onClose}
      onSubmit={edit && !inEditing ? handleEditPractice : onSubmit}
      hideSubmitButton={!edit || inEditing}
      submitLabel={edit && !inEditing ? 'EDIT' : undefined}
      title={edit ? 'EDIT_PRACTICE' : 'NEW_PRACTICE'}
      width="md"
      fullWidth
      form
      disableBackdropClick
      disableEscapeKeyDown
      icon={
        edit ? <DriveFileRenameOutlineRoundedIcon /> : <NoteAddRoundedIcon />
      }
    >
      <DialogContent
        data={data}
        customerData={customerData}
        edit={edit}
        inEditing={inEditing}
        setInEditing={setInEditing}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        handleSetCustomerData={setCustomerData}
        open={open}
      />
    </Dialog>
  );
};

export default PracticeDialog;
